'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const BaseTileBody = renderWithRef('BaseTileBody', null, (r, s)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: s,
        classNames: [
            'swan-base-tile-body'
        ],
        props: r,
        children: r.children
    }));

export { BaseTileBody };
